(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();

      this.transparentOnlyDesktop = this.hasAttribute('data-transparent-only-desktop');
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();

      if (this.transparentOnlyDesktop) {
        const divHeader = document.querySelector('.shopify-section-header');
        divHeader.classList.add('shopify-body-section-header-transparent-only-desktop');
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ((theme.config.mqlSmall && !this.hasAttribute('data-mobile-always-visible')) || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
// Flickity touch scroll prevention
(function(){
  var e,t=!1;
  document.body.addEventListener("touchstart",(function(i){
    if(!i.target.closest(".flickity-slider"))return t=!1;
    t=!0,e={x:i.touches[0].pageX,y:i.touches[0].pageY}
  }));
  document.body.addEventListener("touchmove",(function(i){
    if(t&&i.cancelable){
      var s={x:i.touches[0].pageX-e.x,y:i.touches[0].pageY-e.y};
      Math.abs(s.x)>Flickity.defaults.dragThreshold&&i.preventDefault()
    }
  }),{passive:!1})
})();

// Slideshow Component
class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      small: this.querySelector(".slideshow__left"),
      content: this.querySelector(".slideshow__content"),
      large: this.querySelector(".slideshow__right"),
    };
    this.settings = {
      autorotate: this.dataset.autorotate == "true",
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll(".slideshow__image"),
      slidesLarge: this.elements.large.querySelectorAll(".slideshow__image"),
    };

    // Check if this is the first section on the page
    const section = this.closest('section');
    const isFirstSection = section && section.parentElement.firstElementChild === section;
    
    if (isFirstSection) {
      // Load immediately for first section (critical for LCP)
      this.init();
    } else {
      // Use lazy loading for other sections
      this.initWhenVisible();
    }
    this.matchMedia();
  }

  // Simplified initWhenVisible for this component
  initWhenVisible() {
    const threshold = 600;
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: `0px 0px ${threshold}px 0px` }
    );
    observer.observe(this);
  }

  init() {
    // Check if this is the first section for immediate loading
    const section = this.closest('section');
    const isFirstSection = section && section.parentElement.firstElementChild === section;
    
    const initFlickity = () => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: document.documentElement.dir === 'rtl',
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      });

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: document.documentElement.dir === 'rtl',
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: window.innerWidth < 750 ? true : false,
        asNavFor: this.elements.small,
        adaptiveHeight: true,
        arrowShape: "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll(".flickity-button");
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute("tabindex", "-1");
              });
            }
          },
        },
      });

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: document.documentElement.dir === 'rtl',
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
        dragThreshold: 10,
      });

      this.bindEvents();
    };

    // Execute immediately for first section, with delay for others
    if (isFirstSection) {
      initFlickity();
    } else {
      setTimeout(initFlickity, 300);
    }
  }

  bindEvents() {
    this.flickitySmall.on("scroll", () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall;
        const image = this.settings.slidesSmall[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth
              ? flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target
              : slide.target + flickity.x;
          } else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth
              ? slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth
              : slide.target + flickity.x;
          } else {
            x = slide.target + flickity.x;
          }

          if (!('ontouchstart' in window) && document.documentElement.dir !== 'rtl') {
            image.style.transform = "translateX(" + x * (-1 / 2) + "px)";
          }
        }
      });
    });

    this.flickityLarge.on("scroll", () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth
              ? flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target
              : slide.target + flickity.x;
          } else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth
              ? slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth
              : slide.target + flickity.x;
          } else {
            x = slide.target + flickity.x;
          }

          if (!('ontouchstart' in window) && document.documentElement.dir !== 'rtl') {
            image.style.transform = "translateX(" + x * (-1 / 2) + "px)";
          }
        }
      });
    });

    this.elements.content.querySelector(".flickity-button.next").addEventListener("click", () => {
      this.flickitySmall && this.flickitySmall.next();
      this.stopPlayer();
    });

    this.elements.content.querySelector(".flickity-button.previous").addEventListener("click", () => {
      this.flickitySmall && this.flickitySmall.previous();
      this.stopPlayer();
    });

    this.elements.content.querySelectorAll(".flickity-page-dot").forEach((button) => {
      button.addEventListener("click", () => {
        this.stopPlayer();
      });
    });

    let currentIndex = null, swipeDirection = null;

    // Detect swipe direction
    this.flickityLarge.on("dragMove", (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);
      this.stopPlayer();
    });

    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on("dragEnd", () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {
        if (swipeDirection === "left") {
          this.flickitySmall.next();
        } else {
          this.flickitySmall.previous();
        }
      }
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      this.flickitySmall && this.flickitySmall.stopPlayer();
    }
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? "right" : "left";
  }

  matchMedia() {
    const handleResize = () => {
      this.unload();
      this.init();
    };

    // Listen for media query changes
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    mediaQuery.addListener(handleResize);

    // Store reference for cleanup
    this.mediaQueryHandler = { mediaQuery, handler: handleResize };
  }

  unload() {
    if (this.flickitySmall && typeof this.flickitySmall.destroy === "function") {
      this.flickitySmall.destroy();
    }
    if (this.flickityContent && typeof this.flickityContent.destroy === "function") {
      this.flickityContent.destroy();
    }
    if (this.flickityLarge && typeof this.flickityLarge.destroy === "function") {
      this.flickityLarge.destroy();
    }
  }

  // Cleanup method
  disconnectedCallback() {
    this.unload();
    if (this.mediaQueryHandler) {
      this.mediaQueryHandler.mediaQuery.removeListener(this.mediaQueryHandler.handler);
    }
  }
}

// Define the custom element
customElements.define("slideshow-component", SlideshowComponent);

  } catch(e) { console.error(e); }
})();
})();
